export interface AppConfig {
  key: string;
  namespace: string;
  label: string;
  color: string;
  description: string;
  // Not listed on the home page or in the app switcher.
  hidden?: boolean;
}

export const appsConfig: Record<string, AppConfig> = {
  investment: {
    key: 'investment',
    namespace: 'investment',
    label: 'Investment',
    color: '#ffbf00',
    description:
      'Core investment system: manage investors, orders on Stag Invest app',
  },
  admin: {
    key: 'admin',
    namespace: 'admin',
    label: 'Admin',
    color: 'red',
    description: 'Stag platform system ops, for admins only',
    // Left out of the home page and app switcher; admins reach it from the
    // user menu instead.
    hidden: true,
  },
  catalog: {
    key: 'catalog',
    namespace: 'catalog',
    label: 'Data Catalog',
    color: '#2f54eb',
    description:
      'Investment data: fund, ETF and stock products, banks, fund managers, market data and ICB classification',
  },
  'robo-advisory': {
    key: 'robo-advisory',
    namespace: 'robo-advisory',
    label: 'Robo Advisory',
    color: 'blue',
    description:
      'Customer portfolios, analysis and target allocation, plus survey and health check reports',
  },
  nhsv: {
    key: 'nhsv',
    namespace: 'nhsv',
    label: 'NHSV',
    color: '#1677ff',
    description:
      'NH Securities Vietnam — accounts, orders, and webhooks integration',
  },
  wealth: {
    key: 'wealth',
    namespace: 'wealth',
    label: 'Private Wealth',
    color: '#7c3aed',
    description:
      'Private Wealth management — NAV tracking, fee calculation, customer programs',
  },
  accounting: {
    key: 'accounting',
    namespace: 'accounting',
    label: 'Accounting',
    color: '#13c2c2',
    description: 'Reconciliation and accounting reports across the platform',
  },
  futureflex: {
    key: 'futureflex',
    namespace: 'futureflex',
    label: 'FutureFlex',
    color: '#52c41a',
    description:
      'FutureFlex B2B employee benefit programs — companies, employees, program orders',
  },
  agent: {
    key: 'agent',
    namespace: 'agent',
    label: 'Stag Agent',
    color: '#d97757',
    description:
      'AI agent for ops — look up platform data and manage investment themes in chat',
  },
};
